import { useState, useLayoutEffect } from 'react';

const useMediaQuery = (query, initialState = false) => {
  const [matchMediaQuery, setMatchMediaQuery] = useState(initialState);

  useLayoutEffect(() => {
    let mounted = true;
    const mql = window.matchMedia(query);
    const onChange = () => (mounted ? setMatchMediaQuery(Boolean(mql.matches)) : '');

    mql.addListener(onChange);
    setMatchMediaQuery(mql.matches);
    return () => ((mounted = false), mql.removeListener(onChange));
  }, [query]);

  return matchMediaQuery;
};

export default useMediaQuery;
